import Icon from '../components/Icon.vue'

Icon.register({"cube":{"width":1792,"height":1792,"paths":[{"d":"M896 1629l640-349v-636l-640 233v752zM832 764l698-254-698-254-698 254zM1664 512v768q0 35-18 65t-49 47l-704 384q-28 16-61 16t-61-16l-704-384q-31-17-49-47t-18-65v-768q0-40 23-73t61-47l704-256q22-8 44-8t44 8l704 256q38 14 61 47t23 73z"}]}})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/cube.js
// module id = 1006
// module chunks = 0